/**
 * CollabV3Cover 컴포넌트
 * @description 상세 맨 위 커버와 그 위의 상태 배지. 커버가 없으면(시작한 예시에도 그림이 없으면) 웹
 *   기본 커버 그림을 쓴다 — 앱도 그 자리에 팬워크 기본 커버를 그린다.
 *
 *   배지는 2.0 웹 상세와 같은 규칙이다 — 모으는 중(GATHERING)에는 내지 않는다. 그때는 아무 일도
 *   없는 기본 상태이고, 배지가 늘 붙어 있으면 정작 알려야 할 「끝남 · 취소」 가 묻힌다. 문구는 앱
 *   하단 바의 것(`In progress` · `Ended collab` · `Cancelled`)이다.
 * @example <CollabV3Cover coverUrl={detail.coverUrl} badge={detail.badge} />
 */
import { memo } from "react";

import CollabV3Badge from "./CollabV3Badge";
import {
  COLLAB_V3_COVER_SIZES,
  collabV3DetailStyles,
} from "./CollabV3Detail.styles";
import type {
  CollabV3BadgeProps,
  CollabV3CoverProps,
} from "./CollabV3Detail.types";

import { COLLAB_V3_COPY } from "../../constants/collabV3Copy";
import type { CollabV3StatusBadge } from "../../dtos";
import { AppImage, HEADER_IMAGE_PLACEHOLDER } from "@/shared/ui";

const STATUS_BADGES: Partial<Record<CollabV3StatusBadge, CollabV3BadgeProps>> =
  {
    IN_PROGRESS: {
      text: COLLAB_V3_COPY.status.inProgress,
      tone: "inverse",
      live: true,
    },
    ENDED: { text: COLLAB_V3_COPY.status.past, tone: "inverse" },
    CANCELLED: { text: COLLAB_V3_COPY.status.cancelled, tone: "inverse" },
  };

const CollabV3Cover = memo<CollabV3CoverProps>(({ coverUrl, badge }) => {
  const styles = collabV3DetailStyles.cover;
  const status = STATUS_BADGES[badge];
  const uri = coverUrl ?? "";
  return (
    <div className={styles.root}>
      {coverUrl ? (
        <div aria-hidden className={styles.backdrop}>
          <AppImage uri={coverUrl} sizes={COLLAB_V3_COVER_SIZES} />
        </div>
      ) : null}
      <div className={styles.photo}>
        <AppImage
          uri={uri}
          fallback={HEADER_IMAGE_PLACEHOLDER}
          sizes={COLLAB_V3_COVER_SIZES}
          priority
        />
      </div>
      {status ? (
        <span className={styles.badge}>
          <CollabV3Badge {...status} />
        </span>
      ) : null}
    </div>
  );
});

CollabV3Cover.displayName = "CollabV3Cover";

export default CollabV3Cover;
